<template>
  <div style="position: relative;">

    <div class="credit-button" :class="{ 'credit-zero': showZeroAlert }" :title="creditLastReset ? `เติมเครดิตล่าสุด: ${creditLastReset}` : ''">
      <!-- 🚨 ปรับใหม่ — เดิมใช้ <ButtonLoading /> (overlay สีขาวโปร่งแสง + spinner ลอยทับ) ระหว่างโหลด
           ซึ่งไม่ใช่ "skeleton" จริงๆ แค่บังของเดิมไว้เฉยๆ เปลี่ยนเป็น shimmer skeleton ให้ตรงกับภาษา
           loading ที่เหลือทั้งแอปใช้อยู่แล้ว (เช่น DashboardHomeScreen.vue: .skel/.skel-title) —
           ขนาด/รูปทรงใกล้เคียงเนื้อหาจริง (ไอคอน + ตัวหนังสือ) กันเนื้อหากระโดดตอนสลับเป็นของจริง -->
      <div v-if="!isLoaded" class="credit-skeleton">
        <span class="credit-skel credit-skel-icon"></span>
        <span class="credit-skel credit-skel-text"></span>
      </div>

      <div class="credit-inner" v-else>
        <span class="material-symbols-outlined credit-icon">{{ showZeroAlert ? 'error' : 'bolt' }}</span>
        <span v-if="!showZeroAlert" class="credit-text">
          <span class="credit-label">เครดิต</span>
          <span class="credit-value">{{ credit }}</span>
        </span>
        <span v-else class="credit-alert">เครดิตหมด</span>
      </div>
    </div>
  </div>
</template>

<script>

import { db } from "@/firebase"; // ← import firebase ที่คุณตั้งค่าไว้
import { collection, query, where, onSnapshot } from "firebase/firestore";
import ButtonLoading from "@/components/ButtonLoading.vue";


export default {
  // 🚨 ใหม่ — เดิม import + register EmptyCreditOverlay ไว้แต่ไม่เคยถูกใช้ในเทมเพลตเลยสักจุด (dead
  // import) ตัดออก
  components: { ButtonLoading },

  props: {
    creditLastReset: { type: String, default: {} }
  },
  async mounted() {
    const page = this.$storex.getters.getPageData;
    if (!page || !page.id) return;

    // โหลด subscription ครั้งแรก
    await this.$storex.dispatch("subscriptionModule/loadSubscription", page.id);

    // ฟังเครดิต realtime ตลอดเวลา
    await this.$storex.dispatch("subscriptionModule/listenSubscriptionRealtime", page.id);

    // ฟัง usage realtime
    await this.$storex.dispatch("usageModule/listenUsageRealtime", page.id);

    this.isLoaded = true

    const pageData = this.$storex.getters.getPageData;

    // 📌 1. Listener สำหรับ pendingOrder
    const paymentTransactionQuery = query(
      collection(db, "paymentTransaction"),
      where("pageId", "==", pageData.id)
    );

    this.unsubscribePaymentTransaction = onSnapshot(paymentTransactionQuery, (snapshot) => {
      console.log("👂 pendingOrder snapshot fired!");
      snapshot.docChanges().forEach((change) => {
        if (change.type === "modified") {
          const data = { id: change.doc.id, ...change.doc.data() };
          if (data.status === "COMPLETE") {

            this.$swal.fire({
              title: "ซื้อเพ็กเกจสำเร็จ",
              text: "ขอบคุณที่ใช้บริการ",
              icon: "success"
            });
          }
        }


      });
    });

    // ⚠️ แก้ — เดิมมี `if (this.credit <= 0) { this.$router.push(...package...) }` ตรงนี้ redirect ไป
    // หน้า package ทันทีที่โหลด component นี้ (ซึ่งโหลดใหม่ทุกครั้งที่เลือกเพจ เพราะ choosePage() ใน
    // HomeScreen.vue สั่ง window.location.reload() หลัง navigate) ทำให้เลือกเพจที่เครดิตหมดแล้วโดนเด้ง
    // ไปหน้า package ทันทีแบบไม่ทันตั้งตัว ตัดออกตามที่ตกลงกันไว้ (เหตุผลเดียวกับที่ตัดจุดอื่นทั่วแอปไป
    // แล้ว — BoostMessageModal.vue/PostCard.vue/ManagerCommentScreen.vue/ManagerPageHealth.vue) ตอนนี้
    // มีการ์ดเตือนถาวรที่หน้า DashboardHomeScreen.vue (pr-credit-warning) ทำหน้าที่นี้แทนแล้ว ให้ผู้ใช้
    // กดไปเองเมื่อพร้อม — badge สีแดง "เครดิตหมด" ด้านบนนี้ยังคงอยู่ตามปกติ (แค่ตัดการบังคับ redirect
    // ออกเท่านั้น ไม่ได้แตะการแสดงผล badge เลย)

  },
  data() {
    return {
      isLoaded: false
    }
  },

  computed: {
    credit() {
      const sub = this.$storex.getters["subscriptionModule/getSubscription"];

      // ✅ แก้ — กัน crash ถ้าเอกสารยังไม่มี creditRemaining
      return Number(sub?.creditRemaining || 0).toFixed(2);
    },
    // ✅ ใหม่ — ร้านแพ็กเกจเริ่มต้น (packageId 0) เริ่มที่ 0 เครดิตโดยตั้งใจ (ใช้ AI แชทฟรีผ่าน Autopilot)
    //    ไม่ใช่ "เครดิตหมด" — ไม่โชว์สีแดงเตือน ให้เห็นเป็น "เครดิต 0" ธรรมดา
    showZeroAlert() {
      const sub = this.$storex.getters["subscriptionModule/getSubscription"];
      return Number(this.credit) <= 0 && Number(sub?.packageId) !== 0;
    }
  },
  beforeUnmount() {
    // อย่าลืม unsubscribe ตอน component หาย
    if (this.unsubscribePaymentTransaction) this.unsubscribePaymentTransaction();
  }
}
</script>

<style scoped>
.credit-button {
  background: #fff;
  cursor: default;
  border: 1.5px solid var(--pr-border, #e8e8ee);
  padding: 0.4rem 0.9rem;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  min-height: 36px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.credit-button:hover {
  border-color: var(--pr-black, #0d0d12);
  box-shadow: var(--pr-shadow-sm, 0 1px 3px rgba(13, 13, 18, 0.06));
}

.credit-inner {
  display: flex;
  align-items: center;
  gap: 6px;
}

.credit-icon {
  font-size: 17px;
  color: var(--pr-black, #0d0d12);
  flex-shrink: 0;
}

/* ✅ ใหม่ — เดิมมีแค่ "เครดิต: 120.00" ข้อความเดียวไม่มีลำดับชั้น ตัวเลขกับ label ตัวใหญ่เท่ากันหมด
   แยก label เล็ก/เทา กับตัวเลขใหญ่/หนา ให้ตัวเลข (ข้อมูลสำคัญที่สุด) เด่นกว่า */
.credit-text {
  display: flex;
  align-items: baseline;
  gap: 4px;
  font-family: var(--pr-font-body);
}

.credit-label {
  font-size: 0.78rem;
  font-weight: 500;
  color: var(--pr-sub, #52525e);
}

.credit-value {
  font-size: 0.92rem;
  font-weight: 700;
  color: var(--pr-black, #0d0d12);
}

/* ----------- When credit = 0 ----------- */
.credit-zero {
  border-color: var(--pr-danger-bg, #fef2f2);
  background: var(--pr-danger-bg, #fef2f2);
}

.credit-zero:hover {
  border-color: var(--pr-danger, #dc2626);
}

.credit-zero .credit-icon {
  color: var(--pr-danger, #dc2626);
}

.credit-alert {
  font-family: var(--pr-font-body);
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--pr-danger, #dc2626);
}

/* ✅ ใหม่ — shimmer skeleton แทนที่ ButtonLoading overlay เดิม (ดู comment เหตุผลเต็มๆ ในเทมเพลต) */
.credit-skeleton {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
}

.credit-skel {
  border-radius: 6px;
  background: linear-gradient(
    90deg,
    var(--pr-bg-soft, #f8f8fc) 25%,
    var(--pr-border, #e8e8ee) 37%,
    var(--pr-bg-soft, #f8f8fc) 63%
  );
  background-size: 400% 100%;
  animation: credit-shimmer 1.4s ease-in-out infinite;
}

.credit-skel-icon {
  width: 17px;
  height: 17px;
  border-radius: 50%;
  flex-shrink: 0;
}

.credit-skel-text {
  width: 64px;
  height: 13px;
}

@keyframes credit-shimmer {
  0% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

@media (prefers-reduced-motion: reduce) {
  .credit-skel {
    animation: none;
  }
}
</style>